var n = /-(\w)/g;
function o(i) {
  return i.replace(n, function (r, e) {
    return e.toUpperCase();
  });
}
function c(i, r) {
  r === void 0 && (r = 2);
  for (var e = i + ""; e.length < r;) e = "0" + e;
  return e;
}
export { o as camelize, c as padZero };
